const backgroundFixed = fixed => {
  /**
   * スクロール位置を取得する要素を出力する(`html`or`body`)
   */
  const scrollingElement = () => {
    const browser = window.navigator.userAgent.toLowerCase()
    if ("scrollingElement" in document) return document.scrollingElement
    if (browser.indexOf("webkit") > 0) return document.body
    return document.documentElement
  }

  /**
   * 変数にスクロール量を格納
   */
  const scrollY = fixed
    ? scrollingElement().scrollTop
    : parseInt(document.body.style.top || "0")

  /**
   * CSSで背面を固定
   */
  const styles = {
    position: "fixed",
    overflowY: "hidden",
    top: `${scrollY * -1}px`,
    left: "0",
    width: "100vw",
  }

  if (fixed) {
    Object.keys(styles).forEach(key => {
      document.body.style[key] = styles[key]
    })
    document.documentElement.style.height = "100vh"
  } else {
    document.body.style = ""
    document.documentElement.style = ""
  }

  /**
   * 背面固定解除時に元の位置にスクロールする
   */
  if (!fixed) window.scrollTo(0, scrollY * -1)
}

export { backgroundFixed }
